import Link from 'next/link';
import React__default from 'react';
import styled from '@emotion/styled';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CustomLink = (_a) => {
  var _b = _a, {
    href,
    children,
    passHref = true,
    target = "_self",
    prefetch = false
  } = _b, others = __objRest(_b, [
    "href",
    "children",
    "passHref",
    "target",
    "prefetch"
  ]);
  if (!href) {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, children);
  }
  return /* @__PURE__ */ React__default.createElement(Link, __spreadProps(__spreadValues({
    href
  }, others), {
    passHref,
    legacyBehavior: true,
    prefetch
  }), /* @__PURE__ */ React__default.createElement(Anchor, {
    target,
    className: others.className
  }, children));
};
const Anchor = styled.a`
  text-decoration: none;
  color: unset;
  &:hover {
    color: unset;
  }
  cursor: pointer;
`;

export { CustomLink };
